import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Video } from './style'
import { checkGeolocation } from '../../helpers/geo'
//import ModalAlertInput from '../../components/ModalAlertInput/ModalAlertInput'
//import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { fetchValidarDispositivoStart, validarDispositivoReset }  from '../../services/store/reducers/endpoints/validarDispositivo'
import { fetchCreateDispositivoStart }  from '../../services/store/reducers/endpoints/createDispositivo'
import { fetchHabilitarDispositivoStart, habilitarDispositivoReset }  from '../../services/store/reducers/endpoints/habilitarDispositivo'
import { codigoliberacaoReset, codigoliberacaoSave }  from '../../services/store/reducers/codigoliberacao'

class Loading extends PureComponent { 
 state = {
  titleModal: '',
  messageModal: '',
  titleModalInfo: '',
  messageModalInfo: '',
  codigoverificacao: '',
  imei: '',
  serialNumber: '',
  sendedValidarDispositivo: false,
  sendedHabilitarDispositivo: false
 }

  componentDidMount () {
    
    console.log('-----L')
    this.geo()
    /*this.props.validarDispositivoReset()

    let searchData = this.props.location.search
    let imei = searchData.split('?a=')[1].split('&')[0]
    let serialNumber = searchData.split('b=')[1].split('&')[0]
    this.setState({imei: imei, serialNumber: serialNumber})
     
    let codigoliberacao = this.props.codigoliberacao
    
    if(codigoliberacao.codigo){
      console.log('teste')
      this.setState({sendedValidarDispositivo: true})
      this.props.fetchValidarDispositivoStart({
        "IMEI": this.state.imei,
        "NoSerie": this.state.serialNumber,
        "CodLiberacao": codigoliberacao.codigo
      })
    }else{
      this.openModal()
    }  */
 }
 
 setValue = (value) => {
   this.setState({codigoverificacao: value})
 }

 openModal = () => {
   this.setState({titleModal: 'Atenção!', messageModal: 'Digite o código de verificação, caso não possua entre contato com o Wesley no número (11) 3723-2023.'})
 }

 geo = () => {
   console.log('uee')
  checkGeolocation().then((result) => {
    if(result){
      setTimeout(() => {
        window.location.href = '/home'
     }, 3000)
    } else{
      window.location.href='/report-user?message=Você não está com gps&errorCode=2&from=start'
    }          
  }).catch((e)=> {
    console.log(e)
  })
 }

 /*respostaValidarDispositivo = () => {
  this.props.validarDispositivoReset()
   this.setState({sendedValidarDispositivo: false} )
   const { sagaValidarDispositivo } = this.props
   if(sagaValidarDispositivo.success){
    this.setState({titleModalInfo: 'Sucesso', messageModalInfo: 'Dispositivo validado com sucesso.'})
    this.geo()
   }else{

    //verifica se é para habilitar ao invés de validar
    this.setState({sendedHabilitarDispositivo: true}, () => {
      this.props.fetchHabilitarDispositivoStart({
        "IMEI": this.state.imei,
        "NoSerie": this.state.serialNumber,
        "CodLiberacao": this.props.codigoliberacao.codigo
      })
    } )
    
    
    
   }
   console.log('sagaValidarDispositivo', sagaValidarDispositivo)
  }

  respostaHabilitarDispositivo = () => {
    this.setState({sendedHabilitarDispositivo: false})
    this.props.habilitarDispositivoReset()
    const { sagaHabilitarDispositivo } = this.props
    if(sagaHabilitarDispositivo.success){
      this.setState({titleModalInfo: 'Sucesso', messageModalInfo: 'Dispositivo validado com sucesso.'})
      this.geo()
    }else{
      this.props.codigoliberacaoReset()
      this.setState({titleModalInfo: 'Atenção', messageModalInfo: 'O código de verificação está inválido, um pedido foi enviado para habilitar este dispositivo.'})
    }
  }*/
 
 render() {
  
   return (
    <Container>
      <Video autoPlay loop muted>
        <source src={ require('../../assets/videos/loading.mp4') } type='video/mp4' />               
      </Video>
      {
        /*solicita o codigo de verificação */
          //para colocar os pop up
        /*  this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlertInput 
            tel={false}
            setValue={this.setValue}
            title={this.state.titleModal} 
            message={ this.state.messageModal} 
            onClick={() => { 
              this.setState({titleModal: '', messageModal: ''})
              this.props.codigoliberacaoSave({codigo: this.state.codigoverificacao})
              setTimeout(() => {
                this.setState({sendedValidarDispositivo: true}, () => {
                  this.props.fetchValidarDispositivoStart({
                    "IMEI": this.state.imei,
                    "NoSerie": this.state.serialNumber,
                    "CodLiberacao": this.state.codigoverificacao
                  })
                  console.log('>>>', this.state.codigoverificacao)
                })
              }, 500) 
            } }
            />*/
        }
        {
         /* this.props.sagaValidarDispositivo &&
          this.state.sendedValidarDispositivo &&
          this.respostaValidarDispositivo()*/
        }

        {
        /*  this.props.sagaHabilitarDispositivo &&
          this.state.sendedHabilitarDispositivo &&
          this.respostaHabilitarDispositivo()*/
        }



        {
          /*alerta de mensagem */
          //para colocar os pop up
        /*  this.state.titleModalInfo && 
          this.state.messageModalInfo &&
          this.state.titleModalInfo.length > 0 &&
          this.state.messageModalInfo.length > 0 &&
          <ModalAlert 
            title={this.state.titleModalInfo} 
            message={ this.state.messageModalInfo} 
            onClick={() => { 
              let openModalAgain = this.state.titleModalInfo === 'Sucesso' ? false : true
              
              
              if(openModalAgain){
                this.props.fetchCreateDispositivoStart({
                  "IMEI": this.state.imei,
                  "NoSerie": this.state.serialNumber
                })
                setTimeout(() => {
                  this.setState({messageModalInfo: '', titleModalInfo: ''})
                  window.location.reload()
                }, 1000)
              }else{
                this.setState({messageModalInfo: '', titleModalInfo: ''})
              }
              
           } }
            />*/
        }  
    </Container>
   )
 }
}

const mapStateToProps = state => ({
  codigoliberacao: state.codigoliberacao,
  sagaValidarDispositivo: state.sagaValidarDispositivo.data,
  sagaHabilitarDispositivo: state.sagaHabilitarDispositivo.data,
  
})

const mapDispatchToProps = dispatch => ({
  fetchValidarDispositivoStart: (mss) => dispatch(fetchValidarDispositivoStart(mss)),
  fetchCreateDispositivoStart: (mss) => dispatch(fetchCreateDispositivoStart(mss)),
  fetchHabilitarDispositivoStart: (mss) => dispatch(fetchHabilitarDispositivoStart(mss)),
  validarDispositivoReset: () => dispatch(validarDispositivoReset()),
  habilitarDispositivoReset: () => dispatch(habilitarDispositivoReset()),
  codigoliberacaoReset: () => dispatch(codigoliberacaoReset()),
  
  codigoliberacaoSave: (value) => dispatch(codigoliberacaoSave(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading)



